<script>
  import { onMount, afterUpdate } from "svelte";
  import { fade, slide } from "svelte/transition";
  export let userImg = "https://uinames.com/api/photos/male/19.jpg";
  export let name = "John Doe";
  export let age = 26;
  export let region = "United States";
  export let phone = "555-2648";
  export let email = "john-doe@contactApp.com";
  let menu;
  let container;
  let fades = false;

  onMount(() => {
    menu.addEventListener("click", () => {
      container.classList.toggle("toggle-sidebar");
    });
  });

  afterUpdate(() => {
    fades = true;
  });
</script>

<style>
  .user-container {
    padding: 2.5rem;
    background: #f4f4f4;
    border-radius: 3px;
    flex: 1 0 25%;
  }
  .user-detail {
    border: 1px solid var(--white);
    display: flex;
    flex-direction: column;
    height: 100%;
    background: linear-gradient(
      142deg,
      var(--white) 25%,
      var(--primary-color-light) 25%,
      var(--primary-color-dark) 80%
    );
  }

  .user-photo {
    height: 20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid var(--white);
  }

  .user-photo-img {
    max-width: 17.4rem;
    width: 70%;
    border-radius: 50%;
    display: block;
  }

  .user-info {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .user-list-info {
    margin: 2.5rem 0;
    list-style: none;
    width: 80%;
  }

  .user-list-item {
    text-align: center;
    font-size: 1.6em;
    border-bottom: 1px solid var(--white);
    margin: 1rem 0;
    padding: 0 0 1rem;
    color: var(--white);
  }
  .email {
    display: block;
    color: var(--white);
    text-decoration: none;
  }

  .email:visited {
    color: var(--white);
  }

  .email:hover {
    opacity: 0.8;
  }

  .menu {
    display: none;
    cursor: pointer;
  }

  @media only screen and (max-width: 950px) {
    .user-container {
      position: fixed;
      width: 35rem;
      z-index: 10;
      height: 100%;
      transition: margin 0.3s ease-in-out;
    }

    .menu {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 3.5rem;
      position: absolute;
      width: 5rem;
      height: 5rem;
      top: 3%;
      right: -20%;
      background: rgba(173, 173, 173, 0.4);
      border-radius: 3px;
    }

    .toggle-sidebar {
      margin-left: -35rem;
    }
  }

  @media only screen and (max-width: 768px) {
    .user-container {
      width: 25rem;
    }

    .menu {
      font-size: 2.5rem;
      width: 4rem;
      height: 4rem;
      top: 4.5%;
      right: -25%;
    }

    .toggle-sidebar {
      margin-left: -25rem;
    }
  }

  @media only screen and (max-width: 400px) {
    .user-container {
      width: 23rem;
    }

    .menu {
      right: -25%;
      top: 3.2%;
    }

    .toggle-sidebar {
      margin-left: -23rem;
    }
    .small-text {
      display: block;
    }

    .user-list-item {
      font-size: 1.4rem;
    }
  }

  @media only screen and (max-width: 330px) {
    .user-container {
      width: 20rem;
    }

    .toggle-sidebar {
      margin-left: -20rem;
    }

    .user-list-item {
      font-size: 1.4rem;
    }
  }
</style>

<div class="user-container toggle-sidebar" bind:this={container}>
  <span class="menu" bind:this={menu}>☰</span>
  <div class="user-detail">
    {#if fades}
      <div class="user-photo" transition:fade={{ duration: 500 }}>
        <img class="user-photo-img" src={userImg} alt={name} />
      </div>

      <div class="user-info">

        <ul class="user-list-info" transition:slide={{ duration: 700 }}>
          <li class="user-list-item">
            Name:
            <span class="small-text"> {name}</span>
          </li>
          <li class="user-list-item">
            Age:
            <span class="small-text"> {age}</span>
          </li>
          <li class="user-list-item">
            Region:
            <span class="small-text"> {region}</span>
          </li>
          <li class="user-list-item">
            Phone:
            <span class="small-text"> {phone}</span>
          </li>
          <li class="user-list-item">
            Email:
            <a href="mailto:{email}" class="email">{email}</a>
          </li>
        </ul>

      </div>
    {/if}

  </div>
</div>
